import * as requestFromServer from "./customersCrud";
import { customersSlice, callTypes } from "./customersSlice";

const { actions } = customersSlice;

//request api for customers and save in redux
export const fetchCustomers = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findCustomers(queryParams)
    .then((response) => {
      const { totalCount, entities } = response.data;
      dispatch(actions.customersFetched({ totalCount, entities }));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const sendCustomerExpiryEmail = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .sendCustomerExpiryEmail(queryParams)
    .then((res) => {
      const { message } = res?.data;
      dispatch(actions.expiryEmailCustomer({ message }));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const generateNumbers = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .generateNumbers()
    .then((response) => {
      const { entity } = response.data;
      dispatch(actions.numbersGenerated({ entity }));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
//update message
export const updateMessage = (type, message) => (dispatch) => {
  dispatch(actions.updateMessage({ type, message }));
};
// update Status
export const updateStatus = (payload) => (dispatch) => {
  dispatch(actions.updateStatus(payload));
};
export const updateDownLoadingStatus = (payload) => (dispatch) => {
  dispatch(actions.updateDownLoadingStatus(payload));
};
export const updateImportStatus = (payload) => (dispatch) => {
  dispatch(actions.updateImportStatus(payload));
};
export const updatePrintLedgerStatus = (payload) => (dispatch) => {
  dispatch(actions.updatePrintLedgerStatus(payload));
};

export const createCustomer = (customer, goBack, reset) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createCustomer(customer)
    .then((response) => {
      const { message, entity } = response.data;
      dispatch(actions.customerCreated({ message, entity }));
      !!reset && reset();
      !!goBack && goBack();
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const changeCompleteStatus = (status) => (dispatch) => {
  dispatch(actions.changeCompleteStatus({ status }));
};
export const removeOtherLicense = (index) => (dispatch) => {
  dispatch(actions.removeOtherLicense({ index }));
};
export const updateCustomer = (customer, customerId, goBack, reset) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateCustomer(customer, customerId)
    .then((response) => {
      const { message, entity } = response.data;
      dispatch(actions.customerUpdated({ message, entity }));
      !!reset && reset();
      !!goBack && goBack();
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const updateCustomerLicense = (licenses, customerId, goBack) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateCustomerLicense(licenses, customerId)
    .then((response) => {
      const { message, entity } = response.data;
      dispatch(actions.licenseUpdated({ message, entity }));
      goBack();
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const uploadLicenseToCloud = (license) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .generatePresignedUrls([{ key: license.key }])
    .then((response) => {
      requestFromServer
        .uploadToCloud({ url: response.data[0].url, file: license.field.files ? license.field.files[0] : license.field[0] })
        .then((response) => {
          const url = response.url.split("?")[0];
          license.handleSetRuntimeFieldValue(url);
          dispatch(
            actions.fileUploaded({
              url: url,
              licenseName: license.field.name,
              type: license.type,
              index: license.index,
            })
          );
        })
        .catch((error) => {
          dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteCustomer = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteCustomer(id)
    .then((response) => {
      if (response.status == 200) {
        const { message } = response.data;
        dispatch(actions.customerDeleted({ id, message }));
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateCustomerLogsExportStatus = (payload) => (dispatch) => {
  dispatch(actions.updateCustomerLogsExportStatus(payload));
};
